"use client";

import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheScienceOfALastingFinish() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll();
  return <section id="the-science-of-a-lasting-finish" className="w-full min-h-[85vh] flex flex-col lg:flex-row overflow-hidden bg-secondary">
      {}
      <div className="w-full lg:w-[40%] flex flex-col justify-center px-6 py-16 md:px-12 lg:px-16 xl:px-20 bg-secondary text-secondary-foreground relative z-10">
        <div ref={textRef} className={cn("transition-all duration-1000 ease-out transform", isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <span className="inline-block py-1 px-3 rounded-full bg-primary/10 text-primary text-xs font-bold tracking-wider uppercase mb-6 border border-primary/20">
            Our Process
          </span>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.1] mb-6 font-sans">
            The Science of a <span className="text-primary">Lasting Finish</span>
          </h1>
          
          <p className="text-lg md:text-xl text-secondary-foreground/80 leading-relaxed mb-8 max-w-md">
            In the relentless humidity of North Queensland, standard paint application simply fails. We combat moisture and heat with meticulous surface profiling and premium, climate-resilient coatings that bond at a molecular level.
          </p>
          
          <div className="flex flex-wrap gap-4">
            <Button asChild size="lg" className="text-base font-semibold px-8 h-12">
              <Link to="#timeline">
                View Our Timeline
                <ArrowDown className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="w-full lg:w-[60%] relative min-h-[400px] lg:min-h-full bg-muted" ref={imgRef}>
        <div className={cn("absolute inset-0 w-full h-full transition-opacity duration-1000 delay-300", isImgVisible ? "opacity-100" : "opacity-0")}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559587/img/precision_paint_application_closeup.png" alt="Close-up of precision paint application on a textured surface" className="w-full h-full object-cover object-center" />
          {}
          <div className="absolute inset-0 bg-secondary/10 lg:bg-transparent mix-blend-multiply pointer-events-none" />
        </div>
      </div>
    </section>;
}